import React from 'react';
import { Form } from 'antd';
import DevicesFormItem from '@/features/reports/Common/DevicesFormItem';
import DayJsRangeDateFormitem from '@/features/reports/Common/RangeDateFormItem';
import Buttons from '../Common/Buttons';
import { ReportOptionsLayout } from '../Common/ReportOptionsLayout';

type Props<T> = {
	onSubmit: (values: T) => Promise<void>;
	loading: boolean;
	isExport?: boolean;
	handleCancel?: () => void;
	exportButton?: React.ReactNode | null;
};

const MileagePerStateOptions = <T,>({ onSubmit, loading, isExport = false, handleCancel, exportButton }: Props<T>) => {
	const { layout, style } = ReportOptionsLayout(isExport);

	return (
		<Form onFinish={onSubmit} layout={layout} style={style}>
			<DevicesFormItem />
			<DayJsRangeDateFormitem />
			<Buttons loading={loading} isExport={isExport} handleCancel={handleCancel} exportButton={exportButton} />
		</Form>
	);
};

export default MileagePerStateOptions;
